var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 130,
    viewBox: "0 0 144 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 2,
    r: 2,
    fill: "#E5EBF0"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 16,
    r: 2,
    fill: "#E5EBF0"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 30,
    r: 2,
    fill: "#E5EBF0"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 44,
    r: 2,
    fill: "#E5EBF0"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 58,
    r: 2,
    fill: "#E5EBF0"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 72,
    r: 2,
    fill: "#E5EBF0"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 86,
    r: 2,
    fill: "#E5EBF0"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 100,
    r: 2,
    fill: "#E5EBF0"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 114,
    r: 2,
    fill: "#E5EBF0"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 128,
    r: 2,
    fill: "#E5EBF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.edde508fedff15fd6231a0b23a5fe6a4.svg";
export { ForwardRef as ReactComponent };